import axios from 'axios'

const service = axios.create({
  baseURL: 'http://www.xiaobangkeji.com:32000/api',
  timeout: 10000
})

// 请求时自动带 token
service.interceptors.request.use(config => {
  const token = localStorage.getItem('adminToken')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
})

// 响应处理
service.interceptors.response.use(res => {
  return res.data
}, err => {
  if (err.response && err.response.status === 401) {
    localStorage.removeItem('adminToken')
    window.location.href = '/login'
  }
  return Promise.reject(err)
})

export default service